import { LOCALE_ID,NgModule   } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeCl from '@angular/common/locales/es-CL';
registerLocaleData(localeCl,'es-CL');
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { MarkdownModule } from 'ngx-markdown';
import { FuseModule } from '@fuse';
import { FormsModule } from '@angular/forms';
import { FuseConfigModule } from '@fuse/services/config';
import { FuseMockApiModule } from '@fuse/lib/mock-api';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/mock-api';
import { LayoutModule } from 'app/layout/layout.module';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { ToastrModule } from 'ngx-toastr';
import { MatNativeDateModule } from '@angular/material/core';
// import { CatalogComponent } from './components/catalog/catalog.component';
// import { RouterModule } from '@angular/router';
import { Error404Component } from './components/error/error404/error404.component';
import { Error500Component } from './components/error/error500/error500.component';

//import { ReceptoresComponent } from './components/home/receptores/receptores.component';
//import { ClockComponent } from './components/clock/clock.component';
//import {XsegundoService} from 'app/services/xsegundo.service';
//import { PrinterComponent } from './components/settings/printer/printer.component';
//import {IKeyboardLayouts, keyboardLayouts, MAT_KEYBOARD_LAYOUTS, MatKeyboardModule  } from 'angular-onscreen-material-keyboard';
const routerConfig: ExtraOptions = {
    preloadingStrategy       : PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
        Error404Component,
        Error500Component,
        // ModulosComponent,
        
  //      ClockComponent, 
        // PrinterComponent,
        // SettingsComponent,
      //   ReceptoresComponent,
        // CatalogComponent,
        // RUTformatPipe 
    ],
    imports     : [
        BrowserModule,
        // ReactiveFormsModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        FormsModule,
        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),

        // Core module of your application
        CoreModule,

        // Layout module of your application
        LayoutModule,

        // 3rd party modules that require global configuration via forRoot
        MarkdownModule.forRoot({}),

        // Toastr
        ToastrModule.forRoot(),

        // ANGULAR MATERIAL
        MatNativeDateModule,
     //   MatKeyboardModule,
    ],
    providers   : [
        { provide: LOCALE_ID,  useValue:  'es-CL' } 
   ],    
  //  providers: [XsegundoService],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
